import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=a69e2f58&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a69e2f58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a69e2f58')) {
      api.createRecord('a69e2f58', component.options)
    } else {
      api.reload('a69e2f58', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=a69e2f58&scoped=true&", function () {
      api.rerender('a69e2f58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2VDEA724EdJ2e/JS/comp/Accordion.vue"
export default component.exports